import { render, staticRenderFns } from "./SearchTokenItem.vue?vue&type=template&id=04704af9&scoped=true&"
import script from "./SearchTokenItem.vue?vue&type=script&lang=js&"
export * from "./SearchTokenItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchTokenItem.vue?vue&type=style&index=0&id=04704af9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04704af9",
  null
  
)

export default component.exports